
import Vue from 'vue'
import { Component } from 'vue-property-decorator';

@Component({
  name: 'EmptyComponent'
})
export default class EmptyComponent extends Vue {
}
